import { render, staticRenderFns } from "./LinkArrow.vue?vue&type=template&id=506e90f6&"
import script from "./LinkArrow.vue?vue&type=script&lang=js&"
export * from "./LinkArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports